import React from 'react';
import { Panel } from 'rsuite';
import Dashboard from './Dashboard';
import Copyright from '@/components/Copyright';

const Page = () => {
  return (
    <Panel header={<span>Dashboard</span>}>
      <Dashboard />
      <Copyright />
    </Panel>
  );
};

export default Page;
